<template>
	<el-dialog v-model="dialogVisible" title="停车记录" :before-close="handleClose" width="95vw">
		<el-form ref="form" :model="queryForm" class="record-search-form" label-position="top">
			<div class="record-search-panel">
				<div class="search-fields">
					<el-form-item label="车牌号">
						<el-input
								v-model.trim="queryForm.numberPlate"
								clearable
								placeholder="请输入车牌号"
								@keyup.enter="handleQuery"
						/>
					</el-form-item>
					<el-form-item label="车辆类型">
						<el-select v-model="queryForm.carType" placeholder="请选择" :clearable="true">
							<el-option
									v-for="item in carTypeList"
									:key="item.typeCode"
									:label="item.name"
									:value="item.typeCode"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="时间范围" class="search-item-wide">
						<el-date-picker
								v-model="queryForm.eventTimeRange"
								type="datetimerange"
								range-separator="至"
								start-placeholder="开始时间"
								end-placeholder="结束时间"
								clearable
								@change="handleTimeRangeChange"
						/>
					</el-form-item>
					<el-form-item label="姓名">
						<el-input
								v-model.trim="queryForm.carMasterName"
								clearable
								placeholder="请输入姓名"
								@keyup.enter="handleQuery"
						/>
					</el-form-item>
					<el-form-item label="门牌号">
						<el-input
								v-model.trim="queryForm.address"
								clearable
								placeholder="请输入门牌号"
								@keyup.enter="handleQuery"
						/>
					</el-form-item>
				</div>
				<div class="search-actions">
					<el-button type="primary" @click="handleQuery">查询</el-button>
					<el-button @click="resetQuery">重置</el-button>
				</div>
			</div>
		</el-form>

		<el-table :data="list" style="width: 100%;" stripe border v-loading="listLoading">
			<el-table-column align="center" label="序号" width="50">
				<template #default="{ $index }">
					{{ $index + 1 }}
				</template>
			</el-table-column>
			<el-table-column prop="numberPlate" label="车牌号" align="center" width="100"/>
			<el-table-column prop="amountsPayable" align="center" label="应付金额" width="80">
				<template #default="{ row }">
					{{ formatAmount(row.amountsPayable) }}
				</template>
			</el-table-column>
			<el-table-column align="center" label="实付金额" width="80">
				<template #default="{ row }">
					{{ formatAmount(row.amountActuallyPaid) }}
				</template>
			</el-table-column>
			<el-table-column align="center" label="姓名/门牌号" width="90" show-overflow-tooltip>
				<template #default="{ row }">
					{{ row.visitUnit || "-" }}
				</template>
			</el-table-column>
			<el-table-column align="center" label="进出时间" width="170">
				<template #default="{ row }">
					{{ row.eventTime ? getTime(Number(row.eventTime)) : "-" }}
				</template>
			</el-table-column>
			<el-table-column align="center" label="进出类型" width="80">
				<template #default="{ row }">
					{{ getEventTypeName(row.type) }}
				</template>
			</el-table-column>

			<el-table-column label="车辆类型" align="center" show-overflow-tooltip>
				<template #default="{ row }">
					<el-tag
							effect="dark"
							:type="Number(row.carType) === 0 ? 'danger' : 'success'"
					>
						{{ getCarTypeName(row.carType) }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="carStyleName" label="车型" align="center" width="100" show-overflow-tooltip>
				<template #default="{ row }">
					{{ row.carStyleName || '-' }}
				</template>
			</el-table-column>
			<el-table-column align="center" label="进出关卡" width="120" show-overflow-tooltip>
				<template #default="{ row }">
					{{ row.eventPointName || '-' }}
				</template>
			</el-table-column>

			<el-table-column label="进出图片" width="90px" align="center" show-overflow-tooltip>
				<template #default="{ row }">
					<el-image
							v-if="row.bigImageUrl"
							:preview-src-list="[row.bigImageUrl]"
							preview-teleported
							hide-on-click-modal
							style="width: 42px; height: 34px"
							:src="row.bigImageUrl"
					/>
					<span v-else>-</span>
				</template>
			</el-table-column>

			<el-table-column label="放行方式" width="120px" align="center" show-overflow-tooltip>
				<template #default="{ row }">
					{{ getCarParkReleaseType(row.eventReleaseType) }}
				</template>
			</el-table-column>
			<el-table-column label="备注" min-width="180" align="center" show-overflow-tooltip>
				<template #default="{ row }">
					{{ row.remark || row.remarks || '-' }}
				</template>
			</el-table-column>
		</el-table>

		<el-pagination
				background
				:current-page="queryForm.page"
				:page-size="queryForm.size"
				:page-sizes="[10, 20, 50, 100]"
				:layout="layout"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:total="total"
				style="margin-top: 10px"
		/>
	</el-dialog>
</template>
<script>
import {mapState} from "vuex";
import {carparkUseLogAdmin} from "@/network/api";
import {$timeFormat} from "@/utils/index";
import dayjs from "dayjs";

const getTodayTimeRange = () => [
	dayjs().startOf("day").toDate(),
	dayjs().endOf("day").toDate(),
];

export default {
	data() {
		return {
			list: [],
			dialogVisible: false,
			carTypeOptions: [],
			listLoading: false,
			carStatusOption: ["禁用", "正常", "已过期"],
			layout: "total, sizes, prev, pager, next, jumper",
			carParkReleaseType: [
				{key: 0, name: "未放行"},
				{key: 1, name: "自动抬杆"},
				{key: 2, name: "人工抬杆"},
				{key: 3, name: "手机放行"},
				{key: 4, name: "扫码入场"},
				{key: 5, name: "异常放行"},
			],
			total: 0,
			queryForm: {
				page: 1,
				size: 10,
				numberPlate: '',
				carType: '',
				eventTimeRange: getTodayTimeRange(),
				carMasterName: '',
				address: ''
			},
		};
	},
	computed: {
		...mapState(["carTypeList", "paymentAgencyShortNameOptions"]),
	},
	methods: {
		handleClose(done) {
			done();
		},
		getCarParkReleaseType(key) {
			if (key == null || key === "") {
				return "-";
			}
			if (key == -1) {
				key = 0;
			}
			const item = this.carParkReleaseType.find((i) => i.key == key);
			return item ? item.name : key;
		},
		getEventTypeName(type) {
			if (type === "in") return "入场";
			if (type === "out") return "出场";
			return type || "-";
		},
		formatAmount(value) {
			return value == null || value === "" ? "-" : value;
		},
		timeFormat(time, type) {
			return $timeFormat(time, type);
		},
		getTime(time) {
			return $timeFormat(time, "YYYY-MM-DD HH:mm:ss");
		},
		showDialog() {
			this.dialogVisible = true;
			this.fetchData();
			// 获取所有的车辆类型
			this.$store.dispatch("getAllCarType");
			// 获取支付方式
			this.$store.dispatch("getPaymentAgencyShortNameOptions");
		},

		handleQuery() {
			this.queryForm.page = 1;
			this.fetchData();
		},
		resetQuery() {
			this.queryForm = {
				...this.queryForm,
				page: 1,
				numberPlate: '',
				carType: '',
				eventTimeRange: getTodayTimeRange(),
				carMasterName: '',
				address: '',
			};
			this.fetchData();
		},
		handleSizeChange(val) {
			this.queryForm.size = val;
			this.fetchData();
		},
		handleCurrentChange(val) {
			this.queryForm.page = val;
			this.fetchData();
		},

		// 解决时间搜索 清除后为null的问题
		timeRepairNull(obj) {
			for (const i in obj) {
				if (i != "limit") {
					if (obj[i].value == null) {
						obj[i].value = "";
					}
				}
			}
			return obj;
		},
		getCarTypeName(carType) {
			var carTypeOptions = this.carTypeList;
			if (carType == null || carType === "" || Number(carType) === 0) return "临时车";
			for (let index = 0; index < carTypeOptions.length; index++) {
				if (carTypeOptions[index].typeCode == carType) {
					return carTypeOptions[index].name;
				}
			}
			return carType;
		},
		getPaymentAgencyShortName(paymentAgencyShortName) {
			var paymentAgencyShortNameList = this.paymentAgencyShortNameOptions;
			if (!paymentAgencyShortName) return "-";
			for (let index = 0; index < paymentAgencyShortNameList.length; index++) {
				if (paymentAgencyShortNameList[index].paymentAgencyName == paymentAgencyShortName) {
					return paymentAgencyShortNameList[index].name;
				}
			}
		},
		clearFalseAndNullValues(obj) {
			if (obj === undefined || obj === null) {
				return {};
			}
			const result = {};
			for (const [key, value] of Object.entries(obj)) {
				if (value !== false && value !== null && value !== "") {
					result[key] = value;
				}
			}
			return result;
		},
		async fetchData() {
			this.listLoading = true;
			if (!this.queryForm.eventTimeRange || this.queryForm.eventTimeRange.length !== 2) {
				this.queryForm.eventTimeRange = getTodayTimeRange();
			}

			const params = {
				page: this.queryForm.page,
				size: this.queryForm.size,
				numberPlate: this.queryForm.numberPlate,
				carType: this.queryForm.carType,
				carMasterName: this.queryForm.carMasterName,
				address: this.queryForm.address,
			};
			if (this.queryForm.eventTimeRange && this.queryForm.eventTimeRange.length === 2) {
				params.minInTime = dayjs(this.queryForm.eventTimeRange[0]).valueOf();
				params.maxOutTime = dayjs(this.queryForm.eventTimeRange[1]).valueOf();
			}

			try {
				const res = await carparkUseLogAdmin(this.clearFalseAndNullValues(params));
				const {
					data,
					total,
					code,
					message
				} = res;
				if (code != 10002) {
					this.$message.error(message);
					this.list = [];
					this.total = 0;
					return;
				}
				const records = Array.isArray(data) ? data : (data && data.records) || res.records || [];
				this.list = records;
				if (this.queryForm.page == 1) {
					this.total = (data && data.total) || total || res.total || 0;
				}
			} catch (e) {
				this.list = [];
				this.total = 0;
			} finally {
				this.listLoading = false;
			}
		},
		 handleTimeRangeChange(val) {
			if (val && val.length === 2) {
			const end = dayjs(val[1]);
			// 如果结束时间正好是 00:00:00（未手动调整），则改为 23:59:59
			if (end.hour() === 0 && end.minute() === 0 && end.second() === 0) {
				const newEnd = end.endOf('day').toDate(); // 23:59:59.999
				// 如果只想保留到秒（23:59:59），可以 .second(59).millisecond(0)
				this.queryForm.eventTimeRange = [val[0], newEnd];
			}
			// 否则不做任何修改，保留用户选择的时间
			}
		}
				
	},
};
</script>

<style scoped>
.record-search-form {
	margin-bottom: 14px;
}

.record-search-panel {
	display: flex;
	align-items: flex-end;
	gap: 14px;
	padding: 14px 16px 4px;
	background: #f7f9fc;
	border: 1px solid #e5eaf3;
	border-radius: 6px;
}

.search-fields {
	flex: 1;
	display: grid;
	grid-template-columns:
		minmax(140px, 1fr)
		minmax(140px, 1fr)
		minmax(320px, 2fr)
		minmax(140px, 1fr)
		minmax(140px, 1fr);
	gap: 12px 14px;
	align-items: end;
}

.search-fields :deep(.el-form-item) {
	margin-bottom: 12px;
}

.search-fields :deep(.el-form-item__label) {
	padding-bottom: 4px;
	line-height: 18px;
	color: #4e5969;
	font-weight: 500;
}

.search-fields :deep(.el-input),
.search-fields :deep(.el-select),
.search-fields :deep(.el-date-editor) {
	width: 100%;
}

.search-actions {
	display: flex;
	gap: 8px;
	align-items: center;
	padding-bottom: 12px;
	white-space: nowrap;
}

@media (max-width: 1200px) {
	.record-search-panel {
		align-items: stretch;
		flex-direction: column;
	}

	.search-fields {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.search-item-wide {
		grid-column: span 2;
	}

	.search-actions {
		justify-content: flex-end;
	}
}

@media (max-width: 720px) {
	.search-fields {
		grid-template-columns: 1fr;
	}

	.search-item-wide {
		grid-column: auto;
	}

	.search-actions {
		justify-content: flex-start;
	}
}
</style>


<style>
.el-image-viewer__wrapper {
	z-index: 100000 !important;
}
</style>
